/* tslint:disable */

/**
 */
export class UserSearch {
    rfid?: string;
    barcode?: string;
}
